import React from "react";
import { Row, Col, Typography } from "antd";
import styled from "styled-components";

const { Text } = Typography;

const Container = styled.div`
  width: 100%;
  background: #f7f7f7;
  padding: 13px ;
`;

const DetailsCard = styled.div`
  width: 100%;
  background: #e4dfdf;
  border-radius: 12px;
  padding: 18px 20px;
  box-sizing: border-box;
`;

const Label = styled(Text)`
  display: block;
  font-size: 18px;
  font-weight: 400;
  color: #667085;
`;

const Value = styled(Text)`
  display: block;
  font-size: 18px;
  font-weight: 400;
  color: #344054;
`;

const DescriptionValue = styled(Text)`
  display: block;
  font-size: 20px;
  line-height: 1.5;
  color: #344054;
`;

const FieldRow = styled(Row)`
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

// const GroupDetails = ({updateddetailspage}) => {
//   console.log(updateddetailspage , "updateddetailspage")
//   const groupData = {
//     groupName: "Design",
//     groupKey: "67ehjk",
//     maximumLimit: 20,
//     description:
//       "A dedicated group for aspiring and professional designers alike. Dive into topics ranging from visual design principles to advanced prototyping, participate in hands-on projects, and learn from peer feedback. Enhance your portfolio while building connections with other designers."
//   };

//   return (
//     <Container>
//       <DetailsCard>
//         {/* First Row */}
//         <FieldRow align="middle">
//           <Col xs={24} sm={4} md={3}>
//             <Label>Group Name</Label>
//           </Col>

//           <Col xs={24} sm={20} md={9}>
//             <Value>{groupData.groupName}</Value>
//           </Col>
//         </FieldRow>

//         {/* Second Row */}
//         <FieldRow align="middle">
//           <Col xs={24} sm={4} md={3}>
//             <Label>Group Key</Label>
//           </Col>

//           <Col xs={24} sm={8} md={6}>
//             <Value>{groupData.groupKey}</Value>
//           </Col>

//           <Col xs={24} sm={4} md={3}>
//             <Label>Maximum Limit</Label>
//           </Col>

//           <Col xs={24} sm={8} md={12}>
//             <Value>{groupData.maximumLimit}</Value>
//           </Col>
//         </FieldRow>

//         {/* Description */}
//         <FieldRow>
//           <Col xs={24} sm={4} md={3}>
//             <Label>Description</Label>
//           </Col>

//           <Col xs={24} sm={20} md={21}>
//             <DescriptionValue>
//               {groupData.description}
//             </DescriptionValue>
//           </Col>
//         </FieldRow>
//       </DetailsCard>
//     </Container>
//   );
// };



const GroupDetails = ({ updateddetailspage }) => {
  const groupData = {
    groupName: updateddetailspage?.name || updateddetailspage?.groupName || "—",
    groupKey: updateddetailspage?.key || updateddetailspage?.groupKeyValue || "—",
    maximumLimit: updateddetailspage?.maxLimit || updateddetailspage?.maximumLimit || "—",
    description: updateddetailspage?.description || "—",
  };

  return (
    <Container>
      <DetailsCard>
        <FieldRow align="middle">
          <Col xs={24} sm={4} md={3}>
            <Label>Group Name</Label>
          </Col>
          <Col xs={24} sm={20} md={9}>
            <Value>{groupData.groupName}</Value>
          </Col>
        </FieldRow>

        <FieldRow align="middle">
          <Col xs={24} sm={4} md={3}>
            <Label>Group Key</Label>
          </Col>
          <Col xs={24} sm={8} md={6}>
            <Value>{groupData.groupKey}</Value>
          </Col>

          <Col xs={24} sm={4} md={3}>
            <Label>Maximum Limit</Label>
          </Col>
          <Col xs={24} sm={8} md={12}>
            <Value>{groupData.maximumLimit}</Value>
          </Col>
        </FieldRow>

        <FieldRow>
          <Col xs={24} sm={4} md={3}>
            <Label>Description</Label>
          </Col>
          <Col xs={24} sm={20} md={21}>
            <DescriptionValue>{groupData.description}</DescriptionValue>
          </Col>
        </FieldRow>
      </DetailsCard>
    </Container>
  );
};

export default GroupDetails;